import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const Paginador = (props) => {
  const { onChange } = props;
  const [pagina, setPagina] = useState(0);
  useEffect(() => {
    onChange(pagina);
  }, [pagina]);
  const adelante = () => {
    const page = pagina + 1;
    setPagina(page);
  };
  const regreso = () => {
    const page = pagina >= 1 ? pagina - 1 : pagina;
    setPagina(page);
  };
  return (
    <>
      <div className="flex cursor-pointer w-full h-12 justify-center items-center gap-5 text-blue-500">
        {pagina >= 1 ? (
          <FontAwesomeIcon icon={['fa', 'circle-chevron-left']} size={'2x'} onClick={regreso} />
        ) : (
          ''
        )}
        <div className="text-2xl">{pagina + 1}</div>
        <FontAwesomeIcon icon={['fa', 'circle-chevron-right']} size={'2x'} onClick={adelante} />
      </div>
    </>
  );
};

Paginador.propTypes = {
  onChange: PropTypes.func
};

export default Paginador;
